import { axiosShortQuery } from 'store/libs/baseQuery'
import { yayApi } from '../baseApi'
import { LOAD_NUMBER } from 'config'
import { Activity, User, YayApiResponse } from 'lib/_types'
import { pathActivities, pathActivitiesSingleFeed } from 'lib/paths'
import { isValidActivity } from 'features/Activities'

export const activityApi = yayApi
  .enhanceEndpoints({
    addTagTypes: ['TodayUserBirthday', 'Activities'],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getTodayUserBirthday: build.query<
        User[], // TODO: refactor user type later, this should not be full user
        { birthdate: number }
      >({
        providesTags: ['TodayUserBirthday'],
        query: ({ birthdate }) => ({
          url: `/v1/users/following_born_today`,
          params: {
            birthdate,
          },
        }),
        transformResponse: (res: YayApiResponse<{ users: User[] }>) =>
          res.users,
      }),
      getActivities: build.query({
        providesTags: ['Activities'],
        queryFn: axiosShortQuery<
          { activities: Activity[]; last_timestamp: number | null },
          {
            fromTimeStamp?: number | null
            important: boolean
            singleFeed?: boolean
          }
        >(
          ({ fromTimeStamp, important, singleFeed }) => ({
            url: singleFeed ? pathActivitiesSingleFeed : pathActivities,
            params: {
              from_timestamp: fromTimeStamp || undefined,
              important: singleFeed ? undefined : important,
              number: LOAD_NUMBER,
            },
          }),
          'cas',
          (res) => ({
            ...res,
            activities: res?.activities?.filter(isValidActivity) ?? [],
          })
        ),
      }),
    }),
    overrideExisting: false,
  })

export const { useGetTodayUserBirthdayQuery, useGetActivitiesQuery } =
  activityApi
